import { render, staticRenderFns } from "./ProducerScheduleCard.vue?vue&type=template&id=33fbfc88"
import script from "./ProducerScheduleCard.vue?vue&type=script&lang=js"
export * from "./ProducerScheduleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports